<template>
  <a
    class="md-button"
    v-md-ripple="disabled"
    :class="[themeClass]"
    :href="href"
    :target="target"
    :disabled="disabled || null"
    :rel="newRel"
    v-if="href"
  >
    <slot></slot>
  </a>

  <button
    :id="id"
    v-md-ripple="disabled"
    :name="name"
    class="md-button"
    :class="[themeClass]"
    :aria-label="ariaLabel"
    :type="type"
    :disabled="disabled || null"
    v-else
  >
    <slot></slot>
  </button>
</template>
<style lang="scss" src="./mdButton.theme.scss"></style>
<style lang="scss" src="./mdButton.scss"></style>

<script>
  import theme from '../../core/theme/mixins';

  export default {
    name: 'md-button',
    props: {
      href: String,
      target: String,
      rel: String,
      id: {
        type: String,
        default: undefined
      },
      name: String,
      type: {
        type: String,
        default: 'button'
      },
      disabled: {
        type: Boolean,
        default: undefined
      },
      ariaLabel: {
        type: String
      }
    },
    mixins: [theme],
    computed: {
      newRel() {
        if (this.target === '_blank') {
          return this.rel || 'noopener';
        }

        return this.rel;
      }
    }
  };
</script>
